module.exports = __webpack_public_path__ + "media/entities/1104-43e37c15.png";